<form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;"> {{lang?.create_medical_exam}} </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">


      <div class="form-group col-sm-12">
        <label for="first-name">{{ lang?.examination }}</label>
        <input type="text" class="form-control" formControlName="examination"
          [ngClass]="formErrorClass(createForm.controls.examination, createFormSubmitted)">


      </div>

      <div class="form-group col-sm-12">
        <label for="first-name">{{ lang?.description }}</label>
        <textarea class="form-control" formControlName="description"
          [ngClass]="formErrorClass(createForm.controls.description, createFormSubmitted)"></textarea>
      </div>

      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang?.employees }}</label>

        <ng-multiselect-dropdown formControlName="employees" [data]="app_emp_id" [settings]="dropdownSettings">
        </ng-multiselect-dropdown>
      </div>

      <div class="form-group col-sm-6">
        <label for="first-name">{{ lang?.doctor }}</label>
        <input type="text" class="form-control" formControlName="doctor"
          [ngClass]="formErrorClass(createForm.controls.doctor, createFormSubmitted)">
      </div>


      <div class="form-group col-sm-12">
        <label for="first-name">{{ lang?.notes }}</label>
        <textarea class="form-control" formControlName="notes"
          [ngClass]="formErrorClass(createForm.controls.notes, createFormSubmitted)"></textarea>
      </div>


      <div class="form-group col-sm-12" formArrayName="attach_exists">
        <label>{{ lang?.attachments }}</label>
        <div class="form-group row" *ngFor="let link of attach_exists().controls; let i = index;" [formGroupName]="i">
          <div class="col-sm-11">
            <input type="file" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment1($event,i)"
              formControlName="link">

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)"
              *ngIf=" i!=(attach_exists().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()"
              *ngIf=" i==(attach_exists().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-sm-12" formArrayName="send_email">
        <label>{{ lang?.referenceEmail }}</label>
        <div class="form-group row" *ngFor="let email of send_email().controls; let i=index">
          <div class="col-sm-11">
            <input type="text" class="form-control" formControlName="{{i}}"
              [ngClass]="formErrorClass(send_email().controls[i], createFormSubmitted)">
          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeEmail(i)"
              *ngIf=" i!=(send_email().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addEmail()"
              *ngIf=" i==(send_email().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>


      <!-- <div class="form-group col-sm-12">
        <div>
          <label class="checkbox-inline checkbox-custom-alt">
            <input type="checkbox" formControlName="notification_status" value="Yes"
              [ngClass]="formErrorClass (createForm.controls.notification_status, createFormSubmitted)"><i></i>
            {{ lang?.open }} {{ lang?.action }}
          </label>
        </div>
      </div> -->

      <div class="form-group col-sm-6">
        <button type="submit" class="btn btn-light-grey">{{ lang?.save }}</button>
        <button (click)="bsModalRef.hide()" type="reset" class="btn btn-light-green">{{ lang?.close }}</button>
      </div>

    </div>
  </div>

</form>